import React, { useState } from "react";

export interface ImyData {
    userName: string,
    userNIF: string,
    userAddress: string,
    userPostalCode: string,
    userCity: string,
    userState: string,
    userCountry: string,
    userIVAType: string,
    userIRPFType: string,
    userLan:string,
    userMsg:string,
    userMail?: string
}

interface IMyClient {
    clientName: string,
    clientNIF?: string,
    clientAddress?: string,
    clientPostalCode?: string,
    clientCity?: string,
    clientState?: string,
    clientCountry?: string,
}

interface IInvData {
    totalPrice: number,
    ivaPrice: number,
    irpfPrice: number,
    totalTotal: number,
    invStart: string,
    invEnd: string,
    invNum: string
}

export interface IConArray {
    conLabel:string,
    conName: string,
    conValue: string
}

export interface AppContextInterface {
        myData: ImyData,
        myClient: IMyClient,
        invData: IInvData,
        concept: {
            conNum: number,
            conArray: IConArray[]
        },
        renderInv: boolean,
        newInv: boolean,
        firstTime?: boolean,
  }

  interface MetaAppInter {
      app: AppContextInterface,
      setApp: React.Dispatch<React.SetStateAction<AppContextInterface>>
  }

export const AppContext = React.createContext<MetaAppInter | null>(null);

interface IChild {
    children: JSX.Element
}

export const AppProvider = ( {children}: IChild ) => {

    let startDate: string | Date = new Date();
    let dd = String(startDate.getDate()).padStart(2, '0');
    let mm = String(startDate.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = startDate.getFullYear();
    startDate = dd + '/' + mm + '/' + yyyy;

    let endDate: string | Date = new Date();
    endDate.setDate(endDate.getDate() + 30);
    let dd2 = String(endDate.getDate()).padStart(2, '0');
    let mm2 = String(endDate.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy2 = endDate.getFullYear();
    endDate = dd2 + '/' + mm2 + '/' + yyyy2;

    const [app, setApp] = useState<AppContextInterface>({
        myData: {userName: "", userNIF:"", userAddress:"", userPostalCode:"", userCity:"", userState:"", userCountry:"", userMsg:"", userIVAType:"", userIRPFType:"", userLan:""},
        myClient: {clientName: "", clientNIF:"", clientAddress:"", clientPostalCode:"", clientCity:"", clientState:"", clientCountry:""},
        invData: {totalPrice: 0, ivaPrice: 0, irpfPrice: 0, totalTotal: 0, invStart: startDate, invEnd: endDate, invNum: ""},
        concept: {conNum: 1, conArray: [{conLabel: "Concepto 1", conName: "", conValue: "" }]},
        renderInv: false,
        newInv: false,
    });

    return (
    <AppContext.Provider value={{app, setApp}}>
        {children}
    </AppContext.Provider>
  );
};